/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { path } from 'ramda'
import { firestoreConnect } from 'react-redux-firebase'
import { WEBSITE_CONFIG_COLLECTION, WEBSITE_CONFIG_ID, ENVIRONMENT } from '../Config'

const enhance = compose(
  firestoreConnect([
    {
      collection: WEBSITE_CONFIG_COLLECTION,
      where: ['id', '==', WEBSITE_CONFIG_ID],
    },
  ]),
  connect(({ firestore: { data } }) => ({
    config: path([WEBSITE_CONFIG_COLLECTION, WEBSITE_CONFIG_ID], data),
  })),
)

const ConfigLoader = ({ config, children }) => {
  // Disable Right Click
  // Src: https://stackoverflow.com/questions/24020321/how-to-disable-save-image-as-option-on-right-click
  const captureClick = e => {
    if (!e) e = window.event
    if ((e.type && e.type === 'contextmenu') || (e.button && e.button === 2) || (e.which && e.which === 3)) {
      return false
    }
  }

  useEffect(() => {
    if (WEBSITE_CONFIG_ID === 'adobe') {
      // Append Adobe script for Adobe only.
      const script = document.createElement('script')
      script.src = '//assets.adobedtm.com/launch-EN0727ca599413438887ba43ebb55884b3.min.js'
      script.async = true
      document.body.appendChild(script)
    }

    // Disable Right Click
    // Src: https://stackoverflow.com/questions/24020321/how-to-disable-save-image-as-option-on-right-click
    if (WEBSITE_CONFIG_ID === 'adobe' && (ENVIRONMENT === 'prod' || ENVIRONMENT === 'production')) {
      if (document.layers) document.captureEvents(Event.MOUSEDOWN)
      document.onmousedown = captureClick
      document.oncontextmenu = captureClick
    }
  }, [])

  if (!config) return null
  return children
}

export default enhance(ConfigLoader)
